import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { useCookies } from 'react-cookie';
import { GET_PRODUCT } from '../../services';
import InspectionCopyModal from './InspectionCopyModal';
import { inspectionCopyRequest } from './helpers';
import { BLAZE_AUTH_TOKEN_CODE } from '../../constants';

const InspectionCopyRequestButton = ({ modifier, parent, ...props }) => {
  const { itemId: parentId } = parent;
  const [cookies] = useCookies();
  const [blazeAuthToken, setBlazeAuthToken] = useState('');
  const [inspectionCopyData, setInspectionCopyData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const { data: { getPublishedProduct: productData } = {}, loading, error } = useQuery(
    GET_PRODUCT,
    {
      variables: { id: parentId }
    }
  );
  useEffect(
    () => {
      async function getIcData() {
        const { blazeId } = productData;
        const authToken = cookies[BLAZE_AUTH_TOKEN_CODE];
        const icData = await inspectionCopyRequest(blazeId, authToken);
        setInspectionCopyData(icData);
        setBlazeAuthToken(authToken);
      }

      if (typeof window !== 'undefined' && productData) getIcData();
    },
    [blazeAuthToken, cookies, productData]
  );

  if (loading) return null;
  if (error) return error.message;
  const { display_request_inspection_copy_button: displayButton } = inspectionCopyData || {};

  if (!displayButton) return null;

  return (
    <div className="kp-inspection-copy-request">
      {showModal && (
        <InspectionCopyModal
          {...props}
          hideModal={() => setShowModal(false)}
          blazeAuthToken={blazeAuthToken}
          productData={productData}
          inspectionCopyData={inspectionCopyData}
        />
      )}
      <button
        className="kp-inspection-copy-request button"
        type="button"
        onClick={() => setShowModal(true)}>
        <span className="kp-inspection-copy-request button__text">Inspection Copy</span>
        <div className="kp-inspection-copy-request button__icon">
          <i className="fa-solid fa-up-right-from-square" />
        </div>
      </button>
    </div>
  );
};

InspectionCopyRequestButton.propTypes = {
  parent: PropTypes.object.isRequired,
  modifier: PropTypes.string
};

InspectionCopyRequestButton.defaultProps = {
  modifier: ''
};

export default InspectionCopyRequestButton;
